import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
import { TRAINERS, LOOKUP } from 'utils/constants/collectionNames';
import { FOCUS_AREAS } from 'utils/constants/lookup';
import { TRAINER_PROFILE_PICTURE } from 'utils/constants/storageFolders';
import {
  GET_TRAINER_SUCCEED,
  GET_TRAINER_ERROR,
  UPDATE_TRAINER_ERROR,
  UPDATE_TRAINER_SUCCEED,
  GET_FOCUS_ARES_SUCCESS,
  TRAINING_LOADING_STATE,
  UPDATE_TRAINER_LAST_READ_NOTIFICATION_SUCCEEDED
} from './types';

export const getFocusAreas = () => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = await firestore
    .collection(LOOKUP)
    .doc(FOCUS_AREAS)
    .get();

  if (docRef.exists) {
    dispatch({
      type: GET_FOCUS_ARES_SUCCESS,
      payload: {
        ...docRef.data()
      }
    });
  }
};

// get current trainer full data from Firebase
export const getTrainer = trainerUid => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(TRAINERS).doc(trainerUid);
  dispatch({
    type: TRAINING_LOADING_STATE
  });

  try {
    return docRef.onSnapshot(doc => {
      if (doc.exists) {
        if (doc.data().disabled) window.location = '/';
        dispatch({
          type: GET_TRAINER_SUCCEED,
          payload: {
            ...doc.data(),
            id: doc.id
          }
        });
      } else {
        throw new Error('No such Trainer!');
      }
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: GET_TRAINER_ERROR,
      payload: `error: ${error}`
    });
  }
};

export const updateTrainer = (values, history) => async dispatch => {
  let trainer = { ...values };
  try {
    if (trainer.photo) {
      const ref = firebase.storage().ref();
      const snapshot = await ref
        .child(`${TRAINER_PROFILE_PICTURE}${trainer.id}`)
        .put(trainer.photo);
      const downloadURL = await snapshot.ref.getDownloadURL();
      trainer.photo = downloadURL;
    }

    return updateTrainerInFirebase(trainer, history, dispatch);
  } catch (error) {
    console.log(error);
    dispatch({
      type: UPDATE_TRAINER_ERROR,
      payload: `error: ${error}`
    });
  }
};

export const updateTrainerLastReadNotifications = (
  trainerId,
  date
) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(TRAINERS).doc(trainerId);

  docRef
    .set({ last_read_notification_date: date }, { merge: true })
    .then(() => {
      dispatch({
        type: UPDATE_TRAINER_LAST_READ_NOTIFICATION_SUCCEEDED,
        payload: date
      });
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: UPDATE_TRAINER_ERROR,
        payload: `error: ${error}`
      });
    });
};

const updateTrainerInFirebase = (trainer, history, dispatch) => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(TRAINERS).doc(trainer.id);
  dispatch({
    type: TRAINING_LOADING_STATE
  });
  return docRef
    .set({ ...trainer }, { merge: true })
    .then(function() {
      history.push('/profile');
      return dispatch({
        type: UPDATE_TRAINER_SUCCEED
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: UPDATE_TRAINER_ERROR,
        payload: `error: ${error}`
      });
    });
};
